export interface AnomalyDescription {
  accountName: string
  anomalyDate: string
  anomalyDateID: string
  anomalyNotInteresting: boolean
  apiName: string
  cid: string
  dataSource: string
  dimensions: AnomalyBreakdownDimension[]
  dislikedActions: string[]
  dislikedCauses: string[]
  displayName: string
  explainedAnomaly: boolean
  likedActions: string[]
  likedCauses: string[]
  metric: string
  metricActualValue: number
  metricDifference: number
  metricExpectedValue: number
  metricIncrease: boolean
  selectedRelevantDimensions: AnomalyBreakdownDimension[]
  systemDeterminedAnomaly: boolean
  increaseSentimentPositive: boolean
  userSuppliedAction: string
  userSuppliedCause: string
  userSuppliedEffort: string
  userSuppliedBenefit: string
}

export interface AnomalyState {
  description: null | AnomalyDescription
}

export const defaultAnomaly = {
  description: null,
}

export const anomaly = (
  state: AnomalyState = defaultAnomaly,
  action: ReduxAction,
): AnomalyState => {
  switch (action.type) {
    case 'START_LOADING_ANOMALY_DESCRIPTION': {
      return {
        ...state,
        description: null,
      }
    }
    case 'GET_ANOMALY_DESCRIPTION': {
      return {
        ...state,
        description: { ...action.payload },
      }
    }
    case 'UPDATE_ANOMALY_DESCRIPTION': {
      return {
        ...state,
        description: { ...state.description, ...action.payload },
      }
    }
    default:
      return state
  }
}
